import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './recognition-allowances.loaders';
import { converters } from './recognition-allowances.converters';
import { RecognitionAllowancesFilters } from './recognition-allowances.types';

export const recognitionAllowanceRulesKeys = queryKeyFactory(
  'recognition-allowances',
);

export const useRecognitionAllowances = (
  filters: Partial<RecognitionAllowancesFilters> = {},
) => {
  return useQuery({
    queryKey: recognitionAllowanceRulesKeys.list(filters),
    queryFn: () => loaders.getAllowances({ filters }),
    select: converters.getAllowances,
  });
};

export const useRecognitionAllowanceDetails = (
  employeeId: string,
  filters: Partial<RecognitionAllowancesFilters> = {},
) => {
  return useQuery({
    queryKey: recognitionAllowanceRulesKeys.list(
      'details',
      employeeId,
      filters,
    ),
    queryFn: () => loaders.getAllowanceDetails({ employeeId, filters }),
    select: converters.getAllowanceDetails,
    enabled: !!employeeId,
  });
};

export const useRecognitionAllowanceRules = () => {
  return useQuery({
    queryKey: recognitionAllowanceRulesKeys.list('rules'),
    queryFn: () => loaders.getAllowanceRules(),
    select: converters.getAllowanceRules,
  });
};
